module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AgentRegisterView.js"));
	}, "AgentRegisterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentRegisterView!./src/pages/Store/BusinessManage/AgentRegister/AgentRegisterView.js
// module id = 1710
// module chunks = 418